export const ConditionalComponent = ({ condition, children }) => {
  return condition ? children : null;
};
